import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'hu_HU',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'a34f1990-31d1-47ae-a224-b99e05ad1d14',
  ''
);
